// import React, { useMemo, useState, useEffect } from 'react';
// import { Offcanvas } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
// import Select, { type SingleValue } from 'react-select';
// import { Card, CardBody } from '@components/card/card';
// import { getPagedData, setFilters, setSortOrders, type TableState } from '@store/DynamicFilter/dynamicTableSlice';
// import { useAppDispatch, useAppSelector } from '@store/hooks';

// interface FieldDefinition {
//   name: string;
//   label: string;
//   type: 'string' | 'number' | 'date' | 'boolean' | 'options';
//   options?: Array<{ value: string | number; label: string }>;
// }

// interface EnhancedDynamicFilterProps {
//   fields: FieldDefinition[];
//   tableKey: string;
//   show: boolean;
//   onClose?: () => void;
// }

// interface FilterCondition {
//   id: string;
//   field: string;
//   operator: number;
//   value: string;
// }

// interface SortCondition {
//   id: string;
//   field: string;
//   descending: boolean;
// }

// /** ✅ react-select helpers */
// type RSOption = { value: string; label: string };
// const toStr = (v: any) => (v === null || v === undefined ? '' : String(v));

// /** ✅ react-select styles (مهم داخل Offcanvas بسبب z-index) */

// const defaultTableState: TableState = {
//   data: [],
//   totalItems: 0,
//   filters: [],
//   sortOrders: [],
//   pageIndex: 1,
//   pageSize: 10,
//   loading: false,
//   error: null,
//   endpoint: ''
// };

// export const DynamicFilter: React.FC<EnhancedDynamicFilterProps> = ({ fields, tableKey, show, onClose }) => {
//   const { t } = useTranslation();
//   const dispatch = useAppDispatch();
//   const tableState = useAppSelector(state => (state.dynamicTable as any)[tableKey] as TableState | undefined);

//   const { filters, sortOrders } = tableState ?? defaultTableState;

//   const [filtersList, setFiltersList] = useState<FilterCondition[]>([]);
//   const [sortsList, setSortsList] = useState<SortCondition[]>([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [activeTab, setActiveTab] = useState<'filters' | 'sorting'>('filters');

//   const operators = useMemo(
//     () => [
//       { id: 0, label: t('OpEquals'), types: ['string', 'number', 'date', 'boolean', 'options'] },
//       { id: 1, label: t('OpNotEquals'), types: ['string', 'number', 'date', 'boolean', 'options'] },
//       { id: 2, label: t('OpGreaterThan'), types: ['number', 'date'] },
//       { id: 3, label: t('OpGreaterOrEqual'), types: ['number', 'date'] },
//       { id: 4, label: t('OpLessThan'), types: ['number', 'date'] },
//       { id: 5, label: t('OpLessOrEqual'), types: ['number', 'date'] },
//       { id: 6, label: t('OpContains'), types: ['string'] },
//       { id: 7, label: t('OpStartsWith'), types: ['string'] },
//       { id: 8, label: t('OpEndsWith'), types: ['string'] }
//     ],
//     [t]
//   );

//   /** ✅ react-select options */
//   const fieldOptions: RSOption[] = useMemo(() => fields.map(f => ({ value: f.name, label: f.label })), [fields]);

//   const getOperatorOptions = (fieldName: string): RSOption[] => {
//     const selectedField = fields.find(f => f.name === fieldName);
//     const ops = selectedField ? operators.filter(op => op.types.includes(selectedField.type)) : operators;
//     return ops.map(op => ({ value: String(op.id), label: op.label }));
//   };

//   const sortDirOptions: RSOption[] = useMemo(
//     () => [
//       { value: 'asc', label: t('SortAscendingOption') },
//       { value: 'desc', label: t('SortDescendingOption') }
//     ],
//     [t]
//   );

//   const menuPortalTarget =
//     typeof document !== 'undefined' && document?.body ? (document.body as HTMLElement) : undefined;

//   // استعادة الفلاتر والترتيبات من الـ store
//   useEffect(() => {
//     if (filters.length > 0) {
//       setFiltersList(
//         filters.map(
//           (filter, index) =>
//             ({
//               id: `filter-${index}`,
//               ...filter
//             }) as FilterCondition
//         )
//       );
//     } else {
//       setFiltersList([]);
//     }

//     if (sortOrders.length > 0) {
//       setSortsList(
//         sortOrders.map(
//           (sort, index) =>
//             ({
//               id: `sort-${index}`,
//               ...sort
//             }) as SortCondition
//         )
//       );
//     } else {
//       setSortsList([]);
//     }
//   }, [filters, sortOrders]);

//   const generateId = () => `id-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

//   const addFilter = () => {
//     setFiltersList([
//       ...filtersList,
//       {
//         id: generateId(),
//         field: fields[0]?.name || '',
//         operator: 0,
//         value: ''
//       }
//     ]);
//   };

//   const removeFilter = (id: string) => {
//     setFiltersList(filtersList.filter(filter => filter.id !== id));
//   };

//   const updateFilter = (id: string, updates: Partial<FilterCondition>) => {
//     setFiltersList(filtersList.map(filter => (filter.id === id ? { ...filter, ...updates } : filter)));
//   };

//   const addSort = () => {
//     setSortsList([
//       ...sortsList,
//       {
//         id: generateId(),
//         field: fields[0]?.name || '',
//         descending: false
//       }
//     ]);
//   };

//   const removeSort = (id: string) => {
//     setSortsList(sortsList.filter(sort => sort.id !== id));
//   };

//   const updateSort = (id: string, updates: Partial<SortCondition>) => {
//     setSortsList(sortsList.map(sort => (sort.id === id ? { ...sort, ...updates } : sort)));
//   };

//   const handleApplyAll = async () => {
//     setIsLoading(true);

//     try {
//       const activeFilters = filtersList
//         .filter(f => f.field && f.value !== '')
//         .map(f => ({ field: f.field, operator: f.operator, value: f.value }));

//       const activeSorts = sortsList.filter(s => s.field).map(s => ({ field: s.field, descending: s.descending }));

//       dispatch(setFilters({ tableKey, filters: activeFilters as any }));
//       dispatch(setSortOrders({ tableKey, sortOrders: activeSorts as any }));
//       await dispatch(getPagedData({ tableKey }));
//       if (onClose) onClose();
//     } catch (error) {
//       console.error('Error applying filters:', error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleClearAll = () => {
//     setFiltersList([]);
//     setSortsList([]);
//     dispatch(setFilters({ tableKey, filters: [] }));
//     dispatch(setSortOrders({ tableKey, sortOrders: [] }));
//     dispatch(getPagedData({ tableKey }));
//   };

//   const renderValueInput = (filter: FilterCondition) => {
//     const selectedField = fields.find(f => f.name === filter.field);

//     if (!selectedField)
//       return (
//         <input type='text' placeholder={t('SelectFieldFirst')} disabled className='form-control form-control-sm' />
//       );

//     switch (selectedField.type) {
//       case 'number':
//         return (
//           <input
//             type='number'
//             value={filter.value}
//             onChange={e => updateFilter(filter.id, { value: e.target.value })}
//             className='form-control form-control-sm'
//             placeholder={t('EnterNumber')}
//           />
//         );

//       case 'date':
//         return (
//           <input
//             type='date'
//             value={filter.value}
//             onChange={e => updateFilter(filter.id, { value: e.target.value })}
//             className='form-control form-control-sm'
//           />
//         );

//       case 'boolean': {
//         const boolOptions: RSOption[] = [
//           { value: '', label: t('Select') },
//           { value: 'true', label: t('Yes') },
//           { value: 'false', label: t('No') }
//         ];

//         return (
//           <Select
//             className='w-100'
//             classNamePrefix='react-select'
//             // styles={rsBaseStyles}
//             menuPortalTarget={document.body}
//             styles={{
//               menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//             }}
//             options={boolOptions}
//             value={boolOptions.find(o => o.value === filter.value) ?? null}
//             onChange={(opt: SingleValue<RSOption>) => updateFilter(filter.id, { value: opt?.value ?? '' })}
//           />
//         );
//       }

//       case 'options': {
//         if (!selectedField.options || selectedField.options.length === 0) {
//           return (
//             <input
//               type='text'
//               value={filter.value}
//               onChange={e => updateFilter(filter.id, { value: e.target.value })}
//               className='form-control form-control-sm'
//               placeholder={t('EnterSearchValue')}
//             />
//           );
//         }

//         const optOptions: RSOption[] = selectedField.options.map(o => ({
//           value: toStr(o.value),
//           label: o.label
//         }));

//         return (
//           <Select
//             className='w-100'
//             classNamePrefix='react-select'
//             // styles={rsBaseStyles}
//             menuPortalTarget={document.body}
//             styles={{
//               menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//             }}
//             isClearable
//             placeholder={t('Choose')}
//             options={optOptions}
//             value={optOptions.find(o => o.value === toStr(filter.value)) ?? null}
//             onChange={(opt: SingleValue<RSOption>) => updateFilter(filter.id, { value: opt?.value ?? '' })}
//           />
//         );
//       }

//       default:
//         return (
//           <input
//             type='text'
//             value={filter.value}
//             onChange={e => updateFilter(filter.id, { value: e.target.value })}
//             className='form-control form-control-sm'
//             placeholder={t('EnterSearchValue')}
//           />
//         );
//     }
//   };

//   const hasActiveFilters =
//     filtersList.some(filter => filter.field && filter.value !== '') || sortsList.some(sort => sort.field);

//   return (
//     <>
//       <Offcanvas show={show} onHide={onClose} placement='end' style={{ width: '450px' }} className='shadow-lg'>
//         <Offcanvas.Header closeButton className='border-bottom bg-secondary bg-opacity-20'>
//           <Offcanvas.Title className='w-100'>
//             <div className='d-flex align-items-center justify-content-between'>
//               <div className='d-flex align-items-center'>
//                 <i className='bi bi-funnel me-2 text-theme'></i>
//                 <h5 className='mb-0 fw-bold'>{t('SearchFiltersAndSorting')}</h5>
//               </div>
//               {/* {hasActiveFilters && (
//                 <span className='badge bg-theme'>
//                   {filtersList.filter(f => f.field && f.value).length + sortsList.filter(s => s.field).length}
//                 </span>
//               )} */}
//             </div>
//           </Offcanvas.Title>
//         </Offcanvas.Header>

//         <Offcanvas.Body className='p-0'>
//           <div className='h-100 d-flex flex-column'>
//             {/* تبويبات التنقل */}
//             <div className='border-bottom'>
//               <div className='nav nav-pills nav-justified p-2'>
//                 <button
//                   className={`nav-link btn-sm fw-semibold ${activeTab === 'filters' ? 'active bg-theme text-white' : ''}`}
//                   onClick={() => setActiveTab('filters')}
//                 >
//                   <i className='bi bi-funnel me-2'></i>
//                   {t('SearchFilters')}
//                 </button>

//                 <button
//                   className={`nav-link btn-sm fw-semibold ${activeTab === 'sorting' ? 'active bg-success text-white' : ''}`}
//                   onClick={() => setActiveTab('sorting')}
//                 >
//                   <i className='bi bi-sort-down me-2'></i>
//                   {t('SortResults')}
//                 </button>
//               </div>
//             </div>

//             {/* محتوى التبويبات */}
//             <div className='flex-grow-1' style={{ overflowY: 'auto' }}>
//               {activeTab === 'filters' && (
//                 <div className='p-3'>
//                   <div className='d-flex align-items-center justify-content-between mb-3'>
//                     <h6 className='mb-0 fw-semibold'>
//                       <i className='bi bi-sliders me-2 text-theme'></i>
//                       {t('FilterSettings')}
//                     </h6>
//                     <button onClick={addFilter} className='btn btn-theme btn-sm d-flex align-items-center gap-1'>
//                       <i className='bi bi-plus-lg'></i>
//                       {t('AddFilter')}
//                     </button>
//                   </div>

//                   <div className='d-flex flex-column gap-2'>
//                     {filtersList.length === 0 ? (
//                       <div className='text-center py-4 px-3'>
//                         <div
//                           className='bg-theme bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3'
//                           style={{ width: '60px', height: '60px' }}
//                         >
//                           <i className='bi bi-funnel fs-4 text-theme'></i>
//                         </div>
//                         <h6 className='fw-semibold mb-2'>{t('NoFiltersAdded')}</h6>
//                         <p className='text-muted small mb-0'>{t('AddFilterHint')}</p>
//                       </div>
//                     ) : (
//                       filtersList.map((filter, index) => (
//                         <div key={filter.id}>
//                           <Card className='shadow-sm border-0'>
//                             <CardBody className='p-3'>
//                               <div className='row align-items-center g-2 mb-2'>
//                                 <div className='col-10'>
//                                   <div className='d-flex align-items-center gap-2'>
//                                     <span
//                                       className='badge bg-theme rounded-0 d-flex align-items-center justify-content-center flex-shrink-0'
//                                       style={{ width: '22px', height: '22px', fontSize: '0.7rem' }}
//                                     >
//                                       {index + 1}
//                                     </span>

//                                     {/* ✅ react-select: field */}
//                                     <div className='flex-grow-1'>
//                                       <Select
//                                         className='w-100'
//                                         classNamePrefix='react-select'
//                                         // styles={rsBaseStyles}
//                                         menuPortalTarget={document.body}
//                                         styles={{
//                                           menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                                         }}
//                                         isClearable
//                                         placeholder={t('SelectFieldPlaceholder')}
//                                         options={fieldOptions}
//                                         value={fieldOptions.find(o => o.value === filter.field) ?? null}
//                                         onChange={(opt: SingleValue<RSOption>) => {
//                                           updateFilter(filter.id, {
//                                             field: opt?.value ?? '',
//                                             value: '',
//                                             operator: 0
//                                           });
//                                         }}
//                                       />
//                                     </div>
//                                   </div>
//                                 </div>

//                                 <div className='col-2'>
//                                   <button
//                                     onClick={() => removeFilter(filter.id)}
//                                     className='btn btn-outline-danger btn-sm w-100 d-flex align-items-center justify-content-center'
//                                     style={{ height: '31px' }}
//                                     title={t('DeleteFilter')}
//                                   >
//                                     <i className='bi bi-trash fa-lg'></i>
//                                   </button>
//                                 </div>
//                               </div>

//                               <div className='row g-2 align-items-center'>
//                                 <div className='col-6'>
//                                   {/* ✅ react-select: operator */}
//                                   <Select
//                                     className='w-100'
//                                     classNamePrefix='react-select'
//                                     // styles={rsBaseStyles}
//                                     menuPortalTarget={document.body}
//                                     styles={{
//                                       menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                                     }}
//                                     isDisabled={!filter.field}
//                                     options={getOperatorOptions(filter.field)}
//                                     value={
//                                       getOperatorOptions(filter.field).find(o => o.value === String(filter.operator)) ??
//                                       null
//                                     }
//                                     onChange={(opt: SingleValue<RSOption>) => {
//                                       updateFilter(filter.id, { operator: Number(opt?.value ?? 0) });
//                                     }}
//                                   />
//                                 </div>

//                                 <div className='col-6'>{renderValueInput(filter)}</div>
//                               </div>
//                             </CardBody>
//                           </Card>
//                         </div>
//                       ))
//                     )}
//                   </div>
//                 </div>
//               )}

//               {activeTab === 'sorting' && (
//                 <div className='p-3'>
//                   <div className='d-flex align-items-center justify-content-between mb-3'>
//                     <h6 className='mb-0 fw-semibold'>
//                       <i className='bi bi-arrow-down-up me-2 text-success'></i>
//                       {t('SortSettings')}
//                     </h6>
//                     <button onClick={addSort} className='btn btn-success btn-sm d-flex align-items-center gap-1'>
//                       <i className='bi bi-plus-lg'></i>
//                       {t('AddSort')}
//                     </button>
//                   </div>

//                   <div className='d-flex flex-column gap-2'>
//                     {sortsList.length === 0 ? (
//                       <div className='text-center py-4 px-3'>
//                         <div
//                           className='bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3'
//                           style={{ width: '60px', height: '60px' }}
//                         >
//                           <i className='bi bi-sort-down fs-4 text-success'></i>
//                         </div>
//                         <h6 className='fw-semibold mb-2'>{t('NoSortsAdded')}</h6>
//                         <p className='text-muted small mb-0'>{t('AddSortHint')}</p>
//                       </div>
//                     ) : (
//                       sortsList.map((sort, index) => (
//                         <div key={sort.id}>
//                           <Card className='shadow-sm border-0'>
//                             <CardBody className='p-3'>
//                               <div className='row align-items-center g-2 mb-2'>
//                                 <div className='col-10'>
//                                   <div className='d-flex align-items-center gap-2'>
//                                     <span
//                                       className='badge bg-success rounded-0 d-flex align-items-center justify-content-center flex-shrink-0'
//                                       style={{ width: '22px', height: '22px', fontSize: '0.7rem' }}
//                                     >
//                                       {index + 1}
//                                     </span>

//                                     {/* ✅ react-select: sort field */}
//                                     <div className='flex-grow-1'>
//                                       <Select
//                                         className='w-100'
//                                         classNamePrefix='react-select'
//                                         // styles={rsBaseStyles}
//                                         menuPortalTarget={document.body}
//                                         styles={{
//                                           menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                                         }}
//                                         isClearable
//                                         placeholder={t('SelectSortFieldPlaceholder')}
//                                         options={fieldOptions}
//                                         value={fieldOptions.find(o => o.value === sort.field) ?? null}
//                                         onChange={(opt: SingleValue<RSOption>) =>
//                                           updateSort(sort.id, { field: opt?.value ?? '' })
//                                         }
//                                       />
//                                     </div>
//                                   </div>
//                                 </div>

//                                 <div className='col-2'>
//                                   <button
//                                     onClick={() => removeSort(sort.id)}
//                                     className='btn btn-outline-danger btn-sm w-100 d-flex align-items-center justify-content-center'
//                                     style={{ height: '31px' }}
//                                     title={t('DeleteSort')}
//                                   >
//                                     <i className='bi bi-trash fa-lg'></i>
//                                   </button>
//                                 </div>
//                               </div>

//                               <div className='row g-2 align-items-center'>
//                                 <div className='col-12'>
//                                   {/* ✅ react-select: direction */}
//                                   <Select
//                                     className='w-100'
//                                     classNamePrefix='react-select'
//                                     // styles={rsBaseStyles}
//                                     menuPortalTarget={document.body}
//                                     styles={{
//                                       menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                                     }}
//                                     isDisabled={!sort.field}
//                                     options={sortDirOptions}
//                                     value={
//                                       sortDirOptions.find(o => o.value === (sort.descending ? 'desc' : 'asc')) ?? null
//                                     }
//                                     onChange={(opt: SingleValue<RSOption>) =>
//                                       updateSort(sort.id, { descending: (opt?.value ?? 'asc') === 'desc' })
//                                     }
//                                   />
//                                 </div>
//                               </div>
//                             </CardBody>
//                           </Card>
//                         </div>
//                       ))
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* قسم التحكم السفلي */}
//             <div className='border-top p-3 bg-secondary bg-opacity-20'>
//               <div className='d-flex flex-column gap-3'>
//                 <div className='d-flex gap-2'>
//                   <button
//                     onClick={handleClearAll}
//                     className='btn btn-outline-theme flex-grow-1 d-flex align-items-center justify-content-center gap-2'
//                     disabled={!hasActiveFilters}
//                   >
//                     <i className='bi bi-arrow-clockwise'></i>
//                     {t('Reset')}
//                   </button>

//                   <button
//                     onClick={handleApplyAll}
//                     className='btn btn-theme flex-grow-1 d-flex align-items-center justify-content-center gap-2'
//                     disabled={isLoading}
//                   >
//                     {isLoading ? (
//                       <>
//                         <span className='spinner-border spinner-border-sm'></span>
//                         {t('Applying')}
//                       </>
//                     ) : (
//                       <>
//                         <i className='bi bi-check-lg'></i>
//                         {t('ApplyFilters')}
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </Offcanvas.Body>
//       </Offcanvas>

//       <style>{`
//         .offcanvas-backdrop.show { opacity: 0.0; }
//       `}</style>
//     </>
//   );
// };

import React, { useMemo, useState, useEffect } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Select, { type SingleValue } from 'react-select';
import { Card, CardBody } from '@components/card/card';
import { getPagedData, setFilters, setSortOrders, type TableState } from '@store/DynamicSlice/dynamicTableSlice';
import { useAppDispatch, useAppSelector } from '@store/hooks';

interface FieldDefinition {
  name: string;
  label: string;
  type: 'string' | 'number' | 'date' | 'boolean' | 'options';
  options?: Array<{ value: string | number; label: string }>;
}

interface EnhancedDynamicFilterProps {
  fields: FieldDefinition[];
  tableKey: string;
  show: boolean;
  onClose?: () => void;
}

interface FilterCondition {
  id: string;
  field: string;
  operator: number;
  value: string;
}

interface SortCondition {
  id: string;
  field: string;
  descending: boolean;
}

/** ✅ react-select helpers */
type RSOption = { value: string; label: string };
const toStr = (v: any) => (v === null || v === undefined ? '' : String(v));

/** ✅ react-select styles (مهم داخل Offcanvas بسبب z-index) */

const defaultTableState: TableState = {
  data: [],
  totalItems: 0,
  filters: [],
  sortOrders: [],
  pageIndex: 1,
  pageSize: 10,
  loading: false,
  error: null,
  endpoint: ''
};

// أضف هذه الوظيفة المساعدة قبل مكون DynamicFilter
const getFieldIcon = (type: string): string => {
  switch (type) {
    case 'string':
      return 'bi bi-text-left';
    case 'number':
      return 'bi bi-123';
    case 'date':
      return 'bi bi-calendar';
    case 'boolean':
      return 'bi bi-toggle-on';
    case 'options':
      return 'bi bi-list-check';
    default:
      return 'bi bi-card-text';
  }
};

export const DynamicFilter: React.FC<EnhancedDynamicFilterProps> = ({ fields, tableKey, show, onClose }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const tableState = useAppSelector(state => (state.dynamicTable as any)[tableKey] as TableState | undefined);

  const { filters, sortOrders } = tableState ?? defaultTableState;

  const [filtersList, setFiltersList] = useState<FilterCondition[]>([]);
  const [sortsList, setSortsList] = useState<SortCondition[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState<'filters' | 'sorting'>('filters');

  const operators = useMemo(
    () => [
      { id: 0, label: t('OpEquals'), types: ['string', 'number', 'date', 'boolean', 'options'] },
      { id: 1, label: t('OpNotEquals'), types: ['string', 'number', 'date', 'boolean', 'options'] },
      { id: 2, label: t('OpGreaterThan'), types: ['number', 'date'] },
      { id: 3, label: t('OpGreaterOrEqual'), types: ['number', 'date'] },
      { id: 4, label: t('OpLessThan'), types: ['number', 'date'] },
      { id: 5, label: t('OpLessOrEqual'), types: ['number', 'date'] },
      { id: 6, label: t('OpContains'), types: ['string'] },
      { id: 7, label: t('OpStartsWith'), types: ['string'] },
      { id: 8, label: t('OpEndsWith'), types: ['string'] }
    ],
    [t]
  );

  /** ✅ react-select options */
  // const fieldOptions: RSOption[] = useMemo(() => fields.map(f => ({ value: f.name, label: f.label })), [fields]);

  const fieldOptions = useMemo(
    () =>
      fields.map(f => ({
        value: f.name,
        label: f.label,
        type: f.type // أضف نوع الحقل
      })),
    [fields]
  );

  const getOperatorOptions = (fieldName: string): RSOption[] => {
    const selectedField = fields.find(f => f.name === fieldName);
    const ops = selectedField ? operators.filter(op => op.types.includes(selectedField.type)) : operators;
    return ops.map(op => ({ value: String(op.id), label: op.label }));
  };

  const sortDirOptions: RSOption[] = useMemo(
    () => [
      { value: 'asc', label: t('SortAscendingOption') },
      { value: 'desc', label: t('SortDescendingOption') }
    ],
    [t]
  );

  const menuPortalTarget =
    typeof document !== 'undefined' && document?.body ? (document.body as HTMLElement) : undefined;

  // استعادة الفلاتر والترتيبات من الـ store
  useEffect(() => {
    if (filters.length > 0) {
      setFiltersList(
        filters.map(
          (filter, index) =>
            ({
              id: `filter-${index}`,
              ...filter
            }) as FilterCondition
        )
      );
    } else {
      setFiltersList([]);
    }

    if (sortOrders.length > 0) {
      setSortsList(
        sortOrders.map(
          (sort, index) =>
            ({
              id: `sort-${index}`,
              ...sort
            }) as SortCondition
        )
      );
    } else {
      setSortsList([]);
    }
  }, [filters, sortOrders]);

  const generateId = () => `id-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  const addFilter = () => {
    setFiltersList([
      ...filtersList,
      {
        id: generateId(),
        field: fields[0]?.name || '',
        operator: 0,
        value: ''
      }
    ]);
  };

  const removeFilter = (id: string) => {
    setFiltersList(filtersList.filter(filter => filter.id !== id));
  };

  const updateFilter = (id: string, updates: Partial<FilterCondition>) => {
    setFiltersList(filtersList.map(filter => (filter.id === id ? { ...filter, ...updates } : filter)));
  };

  const addSort = () => {
    setSortsList([
      ...sortsList,
      {
        id: generateId(),
        field: fields[0]?.name || '',
        descending: false
      }
    ]);
  };

  const removeSort = (id: string) => {
    setSortsList(sortsList.filter(sort => sort.id !== id));
  };

  const updateSort = (id: string, updates: Partial<SortCondition>) => {
    setSortsList(sortsList.map(sort => (sort.id === id ? { ...sort, ...updates } : sort)));
  };

  const handleApplyAll = async () => {
    setIsLoading(true);

    try {
      const activeFilters = filtersList
        .filter(f => f.field && f.value !== '')
        .map(f => ({ field: f.field, operator: f.operator, value: f.value }));

      const activeSorts = sortsList.filter(s => s.field).map(s => ({ field: s.field, descending: s.descending }));

      dispatch(setFilters({ tableKey, filters: activeFilters as any }));
      dispatch(setSortOrders({ tableKey, sortOrders: activeSorts as any }));
      await dispatch(getPagedData({ tableKey }));
      if (onClose) onClose();
    } catch (error) {
      console.error('Error applying filters:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClearAll = () => {
    setFiltersList([]);
    setSortsList([]);
    dispatch(setFilters({ tableKey, filters: [] }));
    dispatch(setSortOrders({ tableKey, sortOrders: [] }));
    dispatch(getPagedData({ tableKey }));
  };

  const renderValueInput = (filter: FilterCondition) => {
    const selectedField = fields.find(f => f.name === filter.field);

    if (!selectedField)
      return (
        <input type='text' placeholder={t('SelectFieldFirst')} disabled className='form-control form-control-sm' />
      );

    switch (selectedField.type) {
      case 'number':
        return (
          <input
            type='number'
            value={filter.value}
            onChange={e => updateFilter(filter.id, { value: e.target.value })}
            className='form-control form-control-sm'
            placeholder={t('EnterNumber')}
          />
        );

      case 'date':
        return (
          <input
            type='date'
            value={filter.value}
            onChange={e => updateFilter(filter.id, { value: e.target.value })}
            className='form-control form-control-sm'
          />
        );

      case 'boolean': {
        const boolOptions: RSOption[] = [
          { value: '', label: t('Select') },
          { value: 'true', label: t('Yes') },
          { value: 'false', label: t('No') }
        ];

        return (
          <Select
            className='w-100'
            classNamePrefix='react-select'
            // styles={rsBaseStyles}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
            }}
            options={boolOptions}
            value={boolOptions.find(o => o.value === filter.value) ?? null}
            onChange={(opt: SingleValue<RSOption>) => updateFilter(filter.id, { value: opt?.value ?? '' })}
          />
        );
      }

      case 'options': {
        if (!selectedField.options || selectedField.options.length === 0) {
          return (
            <input
              type='text'
              value={filter.value}
              onChange={e => updateFilter(filter.id, { value: e.target.value })}
              className='form-control form-control-sm'
              placeholder={t('EnterSearchValue')}
            />
          );
        }

        const optOptions: RSOption[] = selectedField.options.map(o => ({
          value: toStr(o.value),
          label: o.label
        }));

        return (
          <Select
            className='w-100'
            classNamePrefix='react-select'
            // styles={rsBaseStyles}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
            }}
            isClearable
            placeholder={t('Choose')}
            options={optOptions}
            value={optOptions.find(o => o.value === toStr(filter.value)) ?? null}
            onChange={(opt: SingleValue<RSOption>) => updateFilter(filter.id, { value: opt?.value ?? '' })}
          />
        );
      }

      default:
        return (
          <input
            type='text'
            value={filter.value}
            onChange={e => updateFilter(filter.id, { value: e.target.value })}
            className='form-control form-control-sm'
            placeholder={t('EnterSearchValue')}
          />
        );
    }
  };

  const hasActiveFilters =
    filtersList.some(filter => filter.field && filter.value !== '') || sortsList.some(sort => sort.field);

  return (
    <>
      <Offcanvas show={show} onHide={onClose} placement='end' style={{ width: '450px' }} className='shadow-lg'>
        <Offcanvas.Header closeButton className='border-bottom bg-secondary bg-opacity-20'>
          <Offcanvas.Title className='w-100'>
            <div className='d-flex align-items-center justify-content-between'>
              <div className='d-flex align-items-center'>
                <i className='bi bi-funnel me-2 text-theme'></i>
                <h5 className='mb-0 fw-bold'>{t('SearchFiltersAndSorting')}</h5>
              </div>
              {/* {hasActiveFilters && (
                <span className='badge bg-theme'>
                  {filtersList.filter(f => f.field && f.value).length + sortsList.filter(s => s.field).length}
                </span>
              )} */}
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className='p-0'>
          <div className='h-100 d-flex flex-column'>
            {/* تبويبات التنقل */}
            <div className='border-bottom'>
              <div className='nav nav-pills nav-justified p-2'>
                <button
                  className={`nav-link btn-sm fw-semibold ${activeTab === 'filters' ? 'active bg-theme text-white' : ''}`}
                  onClick={() => setActiveTab('filters')}
                >
                  <i className='bi bi-funnel me-2'></i>
                  {t('SearchFilters')}
                </button>

                <button
                  className={`nav-link btn-sm fw-semibold ${activeTab === 'sorting' ? 'active bg-success text-white' : ''}`}
                  onClick={() => setActiveTab('sorting')}
                >
                  <i className='bi bi-sort-down me-2'></i>
                  {t('SortResults')}
                </button>
              </div>
            </div>

            {/* محتوى التبويبات */}
            <div className='flex-grow-1' style={{ overflowY: 'auto' }}>
              {activeTab === 'filters' && (
                <div className='p-3'>
                  <div className='d-flex align-items-center justify-content-between mb-3'>
                    <h6 className='mb-0 fw-semibold'>
                      <i className='bi bi-sliders me-2 text-theme'></i>
                      {t('FilterSettings')}
                    </h6>
                    <button onClick={addFilter} className='btn btn-theme btn-sm d-flex align-items-center gap-1'>
                      <i className='bi bi-plus-lg'></i>
                      {t('AddFilter')}
                    </button>
                  </div>

                  <div className='d-flex flex-column gap-2'>
                    {filtersList.length === 0 ? (
                      <div className='text-center py-4 px-3'>
                        <div
                          className='bg-theme bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3'
                          style={{ width: '60px', height: '60px' }}
                        >
                          <i className='bi bi-funnel fs-4 text-theme'></i>
                        </div>
                        <h6 className='fw-semibold mb-2'>{t('NoFiltersAdded')}</h6>
                        <p className='text-muted small mb-0'>{t('AddFilterHint')}</p>
                      </div>
                    ) : (
                      filtersList.map((filter, index) => (
                        <div key={filter.id}>
                          <Card className='shadow-sm border-0'>
                            <CardBody className='p-3'>
                              <div className='row align-items-center g-2 mb-2'>
                                <div className='col-10'>
                                  <div className='d-flex align-items-center gap-2'>
                                    <span
                                      className='badge bg-theme rounded-0 d-flex align-items-center justify-content-center flex-shrink-0'
                                      style={{ width: '22px', height: '22px', fontSize: '0.7rem' }}
                                    >
                                      {index + 1}
                                    </span>

                                    {/* ✅ react-select: field */}
                                    <div className='flex-grow-1'>
                                      <Select
                                        className='w-100'
                                        classNamePrefix='react-select'
                                        // styles={rsBaseStyles}
                                        menuPortalTarget={document.body}
                                        styles={{
                                          menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                                        }}
                                        isClearable
                                        placeholder={t('SelectFieldPlaceholder')}
                                        options={fieldOptions}
                                        value={fieldOptions.find(o => o.value === filter.field) ?? null}
                                        onChange={(opt: SingleValue<RSOption>) => {
                                          updateFilter(filter.id, {
                                            field: opt?.value ?? '',
                                            value: '',
                                            operator: 0
                                          });
                                        }}
                                        formatOptionLabel={(option: any) => (
                                          <div className='d-flex align-items-center gap-2'>
                                            <i className={`${getFieldIcon(option.type)} text-theme fw-bold fa-lg`}></i>
                                            <span>{option.label}</span>
                                          </div>
                                        )}
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className='col-2'>
                                  <button
                                    onClick={() => removeFilter(filter.id)}
                                    className='btn btn-outline-danger btn-sm w-100 d-flex align-items-center justify-content-center'
                                    style={{ height: '31px' }}
                                    title={t('DeleteFilter')}
                                  >
                                    <i className='bi bi-trash fa-lg'></i>
                                  </button>
                                </div>
                              </div>

                              <div className='row g-2 align-items-center'>
                                <div className='col-6'>
                                  {/* ✅ react-select: operator */}
                                  <Select
                                    className='w-100'
                                    classNamePrefix='react-select'
                                    // styles={rsBaseStyles}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                                    }}
                                    isDisabled={!filter.field}
                                    options={getOperatorOptions(filter.field)}
                                    value={
                                      getOperatorOptions(filter.field).find(o => o.value === String(filter.operator)) ??
                                      null
                                    }
                                    onChange={(opt: SingleValue<RSOption>) => {
                                      updateFilter(filter.id, { operator: Number(opt?.value ?? 0) });
                                    }}
                                  />
                                </div>

                                <div className='col-6'>{renderValueInput(filter)}</div>
                              </div>
                            </CardBody>
                          </Card>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              )}

              {activeTab === 'sorting' && (
                <div className='p-3'>
                  <div className='d-flex align-items-center justify-content-between mb-3'>
                    <h6 className='mb-0 fw-semibold'>
                      <i className='bi bi-arrow-down-up me-2 text-success'></i>
                      {t('SortSettings')}
                    </h6>
                    <button onClick={addSort} className='btn btn-success btn-sm d-flex align-items-center gap-1'>
                      <i className='bi bi-plus-lg'></i>
                      {t('AddSort')}
                    </button>
                  </div>

                  <div className='d-flex flex-column gap-2'>
                    {sortsList.length === 0 ? (
                      <div className='text-center py-4 px-3'>
                        <div
                          className='bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3'
                          style={{ width: '60px', height: '60px' }}
                        >
                          <i className='bi bi-sort-down fs-4 text-success'></i>
                        </div>
                        <h6 className='fw-semibold mb-2'>{t('NoSortsAdded')}</h6>
                        <p className='text-muted small mb-0'>{t('AddSortHint')}</p>
                      </div>
                    ) : (
                      sortsList.map((sort, index) => (
                        <div key={sort.id}>
                          <Card className='shadow-sm border-0'>
                            <CardBody className='p-3'>
                              <div className='row align-items-center g-2 mb-2'>
                                <div className='col-10'>
                                  <div className='d-flex align-items-center gap-2'>
                                    <span
                                      className='badge bg-success rounded-0 d-flex align-items-center justify-content-center flex-shrink-0'
                                      style={{ width: '22px', height: '22px', fontSize: '0.7rem' }}
                                    >
                                      {index + 1}
                                    </span>

                                    {/* ✅ react-select: sort field */}
                                    <div className='flex-grow-1'>
                                      <Select
                                        className='w-100'
                                        classNamePrefix='react-select'
                                        // styles={rsBaseStyles}
                                        menuPortalTarget={document.body}
                                        styles={{
                                          menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                                        }}
                                        isClearable
                                        placeholder={t('SelectSortFieldPlaceholder')}
                                        options={fieldOptions}
                                        value={fieldOptions.find(o => o.value === sort.field) ?? null}
                                        onChange={(opt: SingleValue<RSOption>) =>
                                          updateSort(sort.id, { field: opt?.value ?? '' })
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className='col-2'>
                                  <button
                                    onClick={() => removeSort(sort.id)}
                                    className='btn btn-outline-danger btn-sm w-100 d-flex align-items-center justify-content-center'
                                    style={{ height: '31px' }}
                                    title={t('DeleteSort')}
                                  >
                                    <i className='bi bi-trash fa-lg'></i>
                                  </button>
                                </div>
                              </div>

                              <div className='row g-2 align-items-center'>
                                <div className='col-12'>
                                  {/* ✅ react-select: direction */}
                                  <Select
                                    className='w-100'
                                    classNamePrefix='react-select'
                                    // styles={rsBaseStyles}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                                    }}
                                    isDisabled={!sort.field}
                                    options={sortDirOptions}
                                    value={
                                      sortDirOptions.find(o => o.value === (sort.descending ? 'desc' : 'asc')) ?? null
                                    }
                                    onChange={(opt: SingleValue<RSOption>) =>
                                      updateSort(sort.id, { descending: (opt?.value ?? 'asc') === 'desc' })
                                    }
                                  />
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* قسم التحكم السفلي */}
            <div className='border-top p-3 bg-secondary bg-opacity-20'>
              <div className='d-flex flex-column gap-3'>
                <div className='d-flex gap-2'>
                  <button
                    onClick={handleClearAll}
                    className='btn btn-outline-theme flex-grow-1 d-flex align-items-center justify-content-center gap-2'
                    disabled={!hasActiveFilters}
                  >
                    <i className='bi bi-arrow-clockwise'></i>
                    {t('Reset')}
                  </button>

                  <button
                    onClick={handleApplyAll}
                    className='btn btn-theme flex-grow-1 d-flex align-items-center justify-content-center gap-2'
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span className='spinner-border spinner-border-sm'></span>
                        {t('Applying')}
                      </>
                    ) : (
                      <>
                        <i className='bi bi-check-lg'></i>
                        {t('ApplyFilters')}
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <style>{`
        .offcanvas-backdrop.show { opacity: 0.0; }
      `}</style>
    </>
  );
};
